
import { AfterViewInit, Component, HostListener, ViewChild, DOCUMENT, input, signal, Inject, effect, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselComponent, OwlOptions, CarouselModule } from 'ngx-owl-carousel-o';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';

import { PlatformService } from 'src/app/core/services/platform/platform.service';

export enum KEY {
  RIGHT_ARROW = 'ArrowRight',
  LEFT_ARROW = 'ArrowLeft'
}

@Component({
  standalone: true,
  selector: 'webstore-image-carousel-full-screen',
  templateUrl: './image-carousel-full-screen.component.html',
  styleUrls: ['./image-carousel-full-screen.component.scss'],
  imports: [CommonModule, CarouselModule]
})
export class ImageCarouselFullScreenComponent implements AfterViewInit {

  IMAGE_URLS = IMAGE_URLS;

  @ViewChild('previewCarousel') previewCarousel!: CarouselComponent;
  @ViewChild('slideCarousel') slideCarousel!: CarouselComponent;

  isBrowser: boolean;

  isDragging: boolean = false;
  startPosition = 0;

  customOptionsSingleImage: OwlOptions = {
    items: 1,
    loop: false,
    margin: 0,
    autoplay: false,
    dots: true,
    nav: false,
    lazyLoad: true,
    responsive: {
      0: {
        items: 1
      },
      600: {
        items: 1
      },
      900: {
        items: 1
      }
    }
  };

  customOptions: OwlOptions = {
    items: 4,
    loop: false,
    margin: 20,
    autoplay: false,
    autoWidth: false,
    dots: false,
    responsive: {
      0: {
        items: 4
      },
      600: {
        items: 4
      },
      900: {
        items: 4
      }
    },
    nav: false
  };

  readonly previewIndex = input<number>(0);
  readonly imagesListInput = input<string[]>([]);


  //     this.previewImage = this._images?.length ? this._images[0]?.image : '';



  readonly images = computed(() => this._images());

  readonly imagesList = computed(() => this._images());

  private _images = signal<{
    image: string;
    thumbImage: string;
    alt: string;
    title: string;
    widthForSlider: number;
  }[]>([]);

  previewImage = signal<string>('');

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === KEY.LEFT_ARROW) {
      this.previous();
    }
    if (event.key === KEY.RIGHT_ARROW) {
      this.next();
    }
  }

  constructor(
    private platformService: PlatformService,
  ) {
    this.isBrowser = this.platformService.isBrowser();

    effect(() => {
      const images = this.imagesListInput();
      if (Array.isArray(images)) {
        const processedImages = images.map((url: string) => ({
          image: url,
          thumbImage: url,
          alt: '',
          title: '',
          widthForSlider: 120
        }));

        this._images.set(processedImages);
        this.previewImage.set(processedImages?.length ? (processedImages[0]?.image || '') : '');

        if (images.length <= (this.customOptions.items || 4)) {
          this.customOptions = {
            ...this.customOptions,
            autoWidth: true,
            margin: 10
          };
        }
      } else {
        // when no image is set
        this._images.set([]);
        this.previewImage.set('');
      }
    });
  }

  ngAfterViewInit(): void {
    this.previewCarousel.to(this.previewIndex() + '');
  }

  setCarouselStartPosition() {

    const sliderStartPosition = this.slideCarousel?.slidesOutputData?.startPosition;
    const previewStartPosition = this.previewCarousel.slidesOutputData.startPosition;

    const numberOfItemsInSlider = this.customOptions.items;

    if (sliderStartPosition !== undefined && previewStartPosition !== undefined && numberOfItemsInSlider !== undefined) {
      const isInRange = this.getIsInRange({ sliderStartPosition, previewStartPosition, numberOfItemsInSlider });

      if (!isInRange) {
        if (previewStartPosition > sliderStartPosition) {
          this.slideCarousel?.to(this.previewCarousel?.slidesOutputData.startPosition + '');
        } else {
          let targetPosition = sliderStartPosition - numberOfItemsInSlider;

          // handle edge case when target becomes -ve
          targetPosition = targetPosition > 0 ? targetPosition : 0;
          this.slideCarousel?.to(targetPosition + '');
        }
      }
    }
  }

  previous() {
    if (this.previewCarousel?.slidesOutputData?.startPosition !== undefined) {
      this.previewCarousel.to(
        this.previewCarousel.slidesOutputData.startPosition - 1 + ''
      );
    }
  }

  next() {
    if (this.previewCarousel?.slidesOutputData?.startPosition !== undefined) {
      this.previewCarousel.to(
        this.previewCarousel.slidesOutputData.startPosition + 1 + ''
      );
    }
  }

  private getIsInRange({ sliderStartPosition, previewStartPosition, numberOfItemsInSlider }: {
    sliderStartPosition: number;
    previewStartPosition: number;
    numberOfItemsInSlider: number;
  }): boolean {
    return (
      previewStartPosition >= sliderStartPosition &&
      previewStartPosition <= sliderStartPosition +
      (numberOfItemsInSlider - 1)
    );
  }


}

